import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface DataItem {
  name: string;
  value: number;
  color: string;
}

const DonutChart: React.FC = () => {
  // Brand palette - sky to indigo gradient
  const data: DataItem[] = [
    { name: 'Studies booked', value: 124, color: '#07c8f9' },   // sky-aqua
    { name: 'Acquired', value: 98, color: '#0a85ed' },          // brilliant-azure
    { name: 'In-Reporting', value: 12, color: '#0d41e1' },      // bright-indigo
    { name: 'Finalized', value: 86, color: '#09a6f3' },         // fresh-sky
  ];

  return (
    <div className="w-full flex flex-col items-center gap-4 pt-2">
      {/* Chart - larger size */}
      <div className="w-[220px] h-[220px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={100}
              innerRadius={60}
              paddingAngle={3}
              cornerRadius={4}
              dataKey="value"
              strokeWidth={0}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number, name: string) => [`${value}`, name]}
              contentStyle={{
                backgroundColor: '#0b0e10',
                border: 'none',
                borderRadius: '6px',
                padding: '4px 8px',
                fontSize: '11px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
              }}
              itemStyle={{ color: '#fff', fontSize: '11px', padding: 0 }}
              labelStyle={{ fontWeight: '500', marginBottom: '2px', fontSize: '11px' }}
              separator=": "
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Legend - horizontal grid */}
      <div className="grid grid-cols-2 gap-x-6 gap-y-2 w-full max-w-[280px]">
        {data.map((item) => (
          <div key={item.name} className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: item.color }} />
            <span className="text-xs text-muted-foreground truncate">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;